import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPurchaseRequests(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/purchase-request/own', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deletePurchaseRequest(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`purchase/purchase-request/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
